import { useState } from "react";
import { useClaims } from "../../../../../auth/ClaimsProvider";
import { useFeatureFlag } from "shared-ui/src/utils/FeatureFlagHelper";
import { ShiOnePermission } from "../../../../../auth/authorizationTypes";
import { useAppSelector } from "../../../../../functions/hooks/hooks";
import { servicesItemsToShow } from "@components/Navigation/NavItemsToShowHelpers";
import { IRootState } from "../../../../../modules";
import type { ContentUnitDto } from "@lib/ShiOneClient";
import { shallowEqual, useSelector } from "react-redux";
import _ from "lodash";


function useGetSupportMyDevicesPermission() {
  const { hasRoleIn } = useClaims();
  const myDevices = useAppSelector((state) => state.device.myDevices);
  const hasDevices = Array.isArray(myDevices) && myDevices.length > 0;
  return !hasRoleIn("ShiImpersonateVirtualAdmin") && hasDevices;
}

function useGetSupportContractsPermission() {
  const { hasPermission, hasRoleIn, isShi } = useClaims();

  return (
    hasPermission(ShiOnePermission.serviceContractRead)
  );
}

export default function useGetSupportItemsPermission() {
  const { hasPermission, hasRoleIn } = useClaims();

  const showNewRequest = hasPermission(
    ShiOnePermission.supportRequestSubmit,
  );
  const showRequests =   hasPermission(
    ShiOnePermission.supportRequestRead,
  )
  const showServiceReport = hasRoleIn(
    "CustomerAdmin",
    "ShiUser",
    "ShiAdmin",
    "ShiResource",
  );
  const showMyDevices = useGetSupportMyDevicesPermission();
  const showContracts = useGetSupportContractsPermission();
  const showBilling = hasPermission(ShiOnePermission.serviceInvoiceRead);
  const showServiceEngagements = hasPermission(ShiOnePermission.serviceProjectRead);
  const showSupportSection =
    showNewRequest ||
    showRequests ||
    showServiceReport ||
    showMyDevices ||
    showContracts ||
    showBilling ||
    showServiceEngagements;
  return {
    showSupportSection,
    showNewRequest,
    showRequests,
    showServiceReport,
    showMyDevices,
    showContracts,
    showBilling,
    showServiceEngagements,
  };
}
